import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'croreFormat',
    standalone: false
})
export class CroreFormatPipe implements PipeTransform {
    transform(value: number | string, lakh?: boolean): string {
        if (value === null || value === undefined || value === '') return '';
        let num: number;
        // const num = Number(value);
        // Convert string to number if value is a string
        if (typeof value === 'string') {
            num = +value;
        } else {
            num = value;
        }

        const absNum = Math.abs(num);
        const sign = num < 0 ? '-' : '';

        // Less than 1 lakh → absolute number with commas
        if (typeof num === 'number' && !Number.isNaN(num) && absNum < 100000) {
            return sign + absNum.toLocaleString('en-IN');
        }

        // Between 1 lakh and less than 1 crore → show in lakhs
        else if (typeof num === 'number' && !Number.isNaN(num) && absNum >= 100000 && absNum < 10000000) {
            if (lakh) {
                // Convert to lakhs
                const lakhs = absNum / 100000;
                const formatted = lakhs.toFixed(2).replace(/\.?0+$/, ''); // remove trailing zeroes
                return `${sign}${formatted} L`;
            }

            const decimalPart = num - Math.floor(num);
            // Round off based on decimal part
            const roundedValue = decimalPart > 0.5 ? Math.ceil(num) : Math.floor(num);

            return roundedValue.toLocaleString('en-IN');
        }

        // 1 crore and above → show in crores
        else if (typeof num === 'number' && !Number.isNaN(num) && absNum >= 10000000) {
            const crores = absNum / 10000000;
            const formatted = this.formatWithIndianCommas(crores);
            return `${sign}${formatted} Cr`;
        } else if (value) {
            // Handle non-numeric string inputs
            return value.toLocaleString('en-IN');
        }

        return sign + absNum.toLocaleString('en-IN');
    }

    private formatWithIndianCommas(value: number): string {
        // Round to 2 decimal places, remove unnecessary trailing zeros
        const formatted = value.toFixed(2).replace(/\.?0+$/, '');
        return formatted;
    }
}
